export default __webpack_public_path__ + "static/screenshot-2-a4c17489f4d55244d2b2bd78ed3ccbd9.jpg";